module.exports = __webpack_public_path__ + "img/1F61B.1addcf54.svg";